export interface ModelPreparation720Payload {
  id?: number;
  case?: number;
  generatedTxtType1?: string;
  generatedTxt?: string;
  modelPreparationStatusId?: number;
  statusCategory?: string;
  statusDescription?: string;
  filingResponse?: string;
  filingCsv?: string;
  filingTime?: string;
  filingExpediente?: string;
  filingJustificante?: string;
  filingUrlPdf?: string;
  deliveryServerDraft?: string;
  deliveryPathDraft?: string;
  deliveryServerFiled?: string;
  deliveryPathFiled?: string;
  envioId?: string;
}

function toNumber(value: unknown): number | undefined {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : undefined;
}

function toStringValue(value: unknown): string | undefined {
  if (value === null || value === undefined) {
    return undefined;
  }
  const text = String(value).trim();
  return text.length > 0 ? text : undefined;
}

function extractId(input: any, field: string): number | undefined {
  const direct = toNumber(input?.[field]);
  if (direct !== undefined) {
    return direct;
  }
  return toNumber(input?.[field]?.id);
}

export function buildModelPreparation720Payload(input: any): ModelPreparation720Payload {
  const payload: ModelPreparation720Payload = {};

  const id = toNumber(input?.id);
  if (id !== undefined) payload.id = id;

  const caseId = extractId(input, 'case');
  if (caseId !== undefined) payload.case = caseId;

  const generatedTxtType1 = toStringValue(input?.generatedTxtType1);
  if (generatedTxtType1 !== undefined) payload.generatedTxtType1 = generatedTxtType1;

  const generatedTxt = toStringValue(input?.generatedTxt ?? input?.genratedTxt);
  if (generatedTxt !== undefined) payload.generatedTxt = generatedTxt;

  const statusId = extractId(input, 'modelPreparationStatusId') ?? extractId(input, 'modelPreparationStatus');
  if (statusId !== undefined) payload.modelPreparationStatusId = statusId;

  const statusCategory = toStringValue(input?.statusCategory);
  if (statusCategory !== undefined) payload.statusCategory = statusCategory;

  const statusDescription = toStringValue(input?.statusDescription);
  if (statusDescription !== undefined) payload.statusDescription = statusDescription;

  const filingResponse = toStringValue(input?.filingResponse);
  if (filingResponse !== undefined) payload.filingResponse = filingResponse;

  const filingCsv = toStringValue(input?.filingCsv);
  if (filingCsv !== undefined) payload.filingCsv = filingCsv;

  const filingTime = toStringValue(input?.filingTime);
  if (filingTime !== undefined) payload.filingTime = filingTime;

  const filingExpediente = toStringValue(input?.filingExpediente);
  if (filingExpediente !== undefined) payload.filingExpediente = filingExpediente;

  const filingJustificante = toStringValue(input?.filingJustificante);
  if (filingJustificante !== undefined) payload.filingJustificante = filingJustificante;

  const filingUrlPdf = toStringValue(input?.filingUrlPdf);
  if (filingUrlPdf !== undefined) payload.filingUrlPdf = filingUrlPdf;

  const deliveryServerDraft = toStringValue(input?.deliveryServerDraft);
  if (deliveryServerDraft !== undefined) payload.deliveryServerDraft = deliveryServerDraft;

  const deliveryPathDraft = toStringValue(input?.deliveryPathDraft);
  if (deliveryPathDraft !== undefined) payload.deliveryPathDraft = deliveryPathDraft;

  const deliveryServerFiled = toStringValue(input?.deliveryServerFiled);
  if (deliveryServerFiled !== undefined) payload.deliveryServerFiled = deliveryServerFiled;

  const deliveryPathFiled = toStringValue(input?.deliveryPathFiled);
  if (deliveryPathFiled !== undefined) payload.deliveryPathFiled = deliveryPathFiled;

  const envioId = toStringValue(input?.envioId);
  if (envioId !== undefined) payload.envioId = envioId;

  return payload;
}
